module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preview-footer"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sm3": ""
    }
  }, [_c('p', [_vm._v("Previewing: " + _vm._s(_vm._f("truncate")((_vm.config.title), 40, '...')))])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('nav', {
    staticClass: "nav-header"
  }, [_c('ul', {
    staticClass: "nav nav--condensed"
  }, [_c('li', [_c('p', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Available Pages")])]), _vm._v(" "), _vm._l((_vm.config.routes), function(item) {
    return _c('li', [(item.route) ? _c('router-link', {
      attrs: {
        "to": item.route,
        "exact": ""
      }
    }, [_vm._v(_vm._s(item.name))]) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.config.cms_url) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.config.cms_url
    }
  }, [_vm._v("Back To Edit")])]) : _vm._e()], 2)])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ee7ef4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/preview-footer/preview-footer.vue
// module id = 765
// module chunks = 0